(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'emotion', './Notification.css', './NotificationBoxVariant.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('emotion'), require('./Notification.css'), require('./NotificationBoxVariant.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.emotion, global.Notification, global.NotificationBoxVariant);
    global.NotificationBoxVariant = mod.exports;
  }
})(this, function (exports, _react, _emotion, _Notification, _NotificationBoxVariant) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _NotificationBoxVariant2 = _interopRequireDefault(_NotificationBoxVariant);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var levelMap = {
    success: {
      label: 'Success!',
      iconLabel: 'check'
    },
    warn: {
      label: 'Warning:',
      iconLabel: 'info_outline'
    },
    info: {
      label: 'Info:',
      iconLabel: 'info_outline'
    },
    error: {
      label: 'Error!',
      iconLabel: 'highlight_off'
    }
  };

  var NotificationBoxVariant = function NotificationBoxVariant(_ref) {
    var _ref$level = _ref.level,
        level = _ref$level === undefined ? 'info' : _ref$level,
        _ref$isShowingIcon = _ref.isShowingIcon,
        isShowingIcon = _ref$isShowingIcon === undefined ? true : _ref$isShowingIcon,
        _ref$messageLabel = _ref.messageLabel,
        messageLabel = _ref$messageLabel === undefined ? '' : _ref$messageLabel,
        message = _ref.message,
        onCloseHandler = _ref.onCloseHandler;

    var notificationLabel = messageLabel || levelMap[level].label;
    var notificationIconLabel = levelMap[level].iconLabel;
    var prefixStyles = level === 'success' ? { marginRight: 5 } : {};

    return _react2.default.createElement(
      'div',
      { className: _NotificationBoxVariant2.default.notificationVariant + ' notify' + level },
      _react2.default.createElement(
        'span',
        { className: 'material-icons' },
        notificationIconLabel
      ),
      _react2.default.createElement(
        'span',
        {
          className: (0, _emotion.cx)(_Notification.titlePrefixClass, _NotificationBoxVariant2.default.verticalAlign),
          'data-test': 'notification-label',
          style: prefixStyles
        },
        notificationLabel
      ),
      _react2.default.createElement(
        'span',
        { 'data-test': 'notification-message', className: _NotificationBoxVariant2.default.verticalAlign },
        message
      ),
      isShowingIcon && _react2.default.createElement(
        'span',
        {
          className: 'material-icons button-close',
          onClick: onCloseHandler,
          onKeyPress: onCloseHandler,
          role: 'button',
          tabIndex: '0',
          'data-test': 'notification-btn-close'
        },
        'close'
      )
    );
  };

  exports.default = NotificationBoxVariant;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Notifications/NotificationBoxVariant.js
// module id = 1932
// module chunks = 1